import { asDetailResponse, asPaginatedResponse, useApi, usePaginatedApi } from "../../../swr/useApi";
import { warrantyClaimsBuyerService } from "../../api_client";
import type {
  WarrantyClaimDto,
  WarrantyClaimQueryDto,
} from "../../../api";

export type BuyerClaimsQuery = {
  page?: number;
  pageSize?: number;
  status?: string;
};

export function useBuyerWarrantyClaims(query?: BuyerClaimsQuery) {
  return usePaginatedApi<WarrantyClaimDto, BuyerClaimsQuery>({
    key: "buyer-warranty-claims",
    serviceMethod: async (q) =>
      asPaginatedResponse<WarrantyClaimDto>(
        warrantyClaimsBuyerService.listMyClaims(q as unknown as WarrantyClaimQueryDto),
      ),
    query,
    options: { refreshInterval: 15_000 },
  });
}

export function useBuyerClaimDetail(id: string | null) {
  return useApi<WarrantyClaimDto>(
    id ? `buyer-warranty-claim-${id}` : null,
    () => asDetailResponse<WarrantyClaimDto>(warrantyClaimsBuyerService.getBuyerClaimDetail(id!)),
    { refreshInterval: 30_000 },
  );
}
